function CloseButton({ onRemove }) {
    return (
        <div
            type='button'
            className='deleteButton'
            style={{ float: 'right' }}
            onDragOver={(ev) => {
                ev.preventDefault();
                ev.dataTransfer.dropEffect = 'none';
                ev.stopPropagation();
            }}
            onClick={(ev) => {
                ev.stopPropagation();
                if (onRemove) onRemove();
            }}
        >
            X
        </div>
    );
}

export default CloseButton;